import { createFileRoute } from '@tanstack/react-router';
import ReportsPage from '../../components/manager/ReportsPage';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/reports')({
  component: ReportsRoute,
});

function ReportsRoute() {
  return (
    <ManagerPortal>
      <ReportsPage />
    </ManagerPortal>
  );
}
